import { render, staticRenderFns } from "./AktivitasCalendar.vue?vue&type=template&id=03010260&scoped=true&lang=html&"
import script from "./AktivitasCalendar.vue?vue&type=script&lang=js&"
export * from "./AktivitasCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03010260",
  null
  
)

export default component.exports